<template>
  <div>
    <div v-if="!isSubStatusPendingActive && getIsUserSubstituted" class="flex set-status"
         :content="$t('vue2.sub_scheduler.is_substituted')"
         v-tippy="{
              placement: 'left',
               arrow: false,
             animateFill: false,
                animation : 'shift-away',
              zIndex: '999999992',
               boundary: 'window'
            }">
      <div class="dot"></div>
    </div>
    <div v-else class="flex set-status pointer"
         :class="'do-' + dropdownPlacement"
         v-on-clickaway="closeDropDown"
         @click="showDropdown = true">
      <div class="dot"
           :class="[statusDotClass, { 'mini-dot--loading': isSubmitting }]">
      </div>
      <div class="arrow icon-arrow-down"></div>
      <div class="dropdown sub-status__dropdown" :class="{'sub-status__dropdown--loading': isSubmitting}"
           v-if="showDropdown">
        <div class="do-spinner__container" v-if="isSubmitting">
          <div class="do-spinner do-spinner--large"></div>
        </div>
        <ul class="sub-status__dropdown__list">
          <li @click.stop="setStatus(0)" v-if="!getIsUserSubstituted">
            <div class="dot dot-white"></div>
            {{ $t('vue2.sub_scheduler_popover.not_handled') }}
          </li>
          <li @click.stop="setStatus(2)" v-if="isSubStatusPendingActive">
            <div class="dot dot-yellow"></div>
            {{ $t('vue2.sub_scheduler_popover.pending') }}
          </li>
          <li @click.stop="setStatus(1)">
            <div class="dot"></div>
            {{ $t('vue2.sub_scheduler_popover.handled') }}
          </li>
          <li @click.stop="setStatusForAll(1)" v-if="othersOnLessonAbsence.length > 0">
            <div class="dot"></div>
            {{ $t('vue2.sub_scheduler_popover.handled_for_absence') }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import docendo from '../../../docendo'

export default {
  mixins: [clickaway],
  props: {
    user: {
      type: Object,
      default: null
    },
    // which user is absence and being substituted
    userCalendarId: {
      type: Number
    },
    lesson: {
      type: Object,
      default: () => {
      }
    },
    statusProp: {
      type: Number,
      default: 0
    },
    dropdownPlacement: {
      type: String,
      default: 'bottom-end'
    },
    othersOnLesson: {
      type: Array,
      default: []
    },
    isSubStatusPendingActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusDotClass () {
      if (this.status === 2) {
        return 'dot-yellow'
      }
      if (!this.status || this.status === 0) {
        return 'dot-white'
      }
    },
    substitution_status () {
      return this.lesson.substitution_status ? JSON.parse(this.lesson.substitution_status) : {}
    },
    status () {
      return this.substitution_status[this.userCalendarId] ? this.substitution_status[this.userCalendarId].status : null
    },
    othersOnLessonAbsence () {
      return this.othersOnLesson.filter(user => user.v_isUserAbsentFromLesson && user.v_isUserAbsentFromLesson.length > 0).map(user => user.user_calendar_id)
    },
    getIsUserSubstituted () {
      const isUserSubstituted = this.lesson.calendar_events.some(calEvent => calEvent.substitute_for_user_id === this.user.id)
      return isUserSubstituted
    }
  },
  data () {
    return {
      showDropdown: false,
      isSubmitting: false
    }
  },
  watch: {
    statusProp (val, oldVal) {
      this.setStatus(this.statusProp)
    }
  },
  methods: {
    setStatusForAll () {
      this.isSubmitting = true
      const calendarIds = [this.userCalendarId]
      const otherAbsentUsers = JSON.parse(JSON.stringify(this.othersOnLessonAbsence))
      const allCalendarIds = calendarIds.concat(otherAbsentUsers)
      let statusData = {...this.substitution_status}
      allCalendarIds.forEach(id => {
        statusData[id] = {'status': 1}
      })
      docendo.updateEvent(this.lesson.school_id, this.lesson.id, {substitution_status: JSON.stringify(statusData)}, success => {
        this.$store.commit('updateSubStatusOnEvent', {
          'eventId': this.lesson.id,
          'status': JSON.stringify(statusData)
        })
        this.isSubmitting = false
        this.closeDropDown()
      })
    },
    setStatus (num) {
      this.isSubmitting = true
      const statusData = {...this.substitution_status}
      // Update or remove the status for the current user
      if (num === 0) {
        // User is not there then cancel request
        if (!statusData[this.userCalendarId]) {
          this.isSubmitting = false
          this.closeDropDown()
          return
        }
        delete statusData[this.userCalendarId]
      } else {
        statusData[this.userCalendarId] = {status: num}
      }
      const payload = {
        substitution_status: JSON.stringify(statusData)
      }
      docendo.updateEvent(this.lesson.school_id, this.lesson.id, payload, success => {
        if (success) {
          // Commit the updated status to the Vuex store
          this.$store.commit('updateSubStatusOnEvent', {
            eventId: this.lesson.id,
            status: payload.substitution_status
          })
        } else {
          console.error('Failed to update substitution status')
        }
        // Reset the submission state
        this.isSubmitting = false
        this.closeDropDown()
      })
    },
    closeDropDown () {
      if (!this.showDropdown) {
        return
      }
      this.showDropdown = false
    }
  }
}
</script>


<style scoped>
@import "../../../assets/css/variables.css";
.set-status {
  width: 38px;
  align-items: center;
  position: relative;
}

.dot {
  position: relative;
  min-width: 15px;
  min-height: 15px;
  background-color: #3ecf8e;
  border-radius: 50%;
  margin-right: 5px;
  border: 1px solid #3ecf8e;
}

.dot-white {
  background-color: #ffffff;
  border-color: var(--dark-blue);
}

.dot-yellow {
  background-color: #f0b100;
  border-color: #f0b100;
}

.dropdown {
  position: absolute;
  top: 0;
  right: 0;
  width: 144px;
  z-index: 100;
  background-color: #ffffff;
  font-size: 14px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12), 0 3px 1px -2px rgba(0, 0, 0, .2);
  border-radius: 4px;
}

.do-bottom-start .dropdown {
  right: auto;
  left: 0;
}

.dropdown li {
  display: flex;
  clear: both;
  color: rgba(0, 0, 0, .87);
  cursor: pointer;
  min-height: 50px;
  width: 100%;
  text-align: left;
  text-transform: none;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 6px;
  line-height: 1.5;
}

.dropdown li:hover {
  background-color: #f6f7f8;
}

.dropdown.sub-status__dropdown ul li {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: normal;
}

.dot--loading:after {
  content: '';
  position: absolute;
  z-index: 2;
  background: transparent;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #d0d0d0; /* Light grey */
  border-top: 2px solid var(--purple); /* Blue */
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.sub-status__dropdown--loading .sub-status__dropdown__list {
  opacity: 0;
  pointer-events: none;
}

.sub-status__dropdown .do-spinner__container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mini-dot--loading::before {
  content: '';
  position: absolute;
  z-index: 2;
  top: -3px;
  left: -3px;
  right: -1px;
  bottom: -1px;
  /* background: red; */
  height: 15px;
  width: 15px;
  border-radius: 50%;
  border: 2px solid var(--primary);
  border-top: 2px solid transparent;
  animation: spin 0.7s linear infinite;
}
</style>



// WEBPACK FOOTER //
// SchedulerItemPopoverStatus.vue?97d65210